import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router";

const NotFoundPage = () => {
	const navigate = useNavigate();
	return (
		<Box
			sx={{
				minHeight: "min(100svh, 100vh)",
				display: "grid",
				placeItems: "center",
				p: 2,
			}}
		>
			<Box sx={{ textAlign: "center" }}>
				<Typography variant="h3" gutterBottom>
					404 - Page Not Found
				</Typography>
				<Typography variant="body1" sx={{ mb: 2 }}>
					The page you are looking for does not exist.
				</Typography>
				<Button variant="contained" onClick={() => navigate("/")}>
					Go Home
				</Button>
			</Box>
		</Box>
	);
};

export default NotFoundPage;
